<script>
  import { onMount } from "svelte";
  import { result } from "../store.js";

  export let item = {
    type: "multi-option",
    required: false,
    title: "",
    description: "",
    placeholder: "",
    options: [],
  };
  export let index = 0;
  let resultList = {};

  onMount(() => {
    // input.focus();
    $result[index] = "";
  });

  function handleChange(e, i) {
    resultList[i] = { value: e.target.value, checked: e.target.checked };

    let resultString = "";
    for (let r in resultList) {
      if (resultList[r].checked)
        resultString
          ? (resultString += ", " + resultList[r].value)
          : (resultString = resultList[r].value);
    }
    $result[index] = resultString;
  }
</script>

<div class="checkbox-container">
  {#each item.options as option, i}
    <label>
      <input
        type="checkbox"
        value={option}
        on:change={(e) => handleChange(e, i)}
      />
      {option}
    </label>
    <!-- <label>
    <input
      type="radio"
      value={option}
      checked={selected === option}
      on:change={onChange}
    />
    {option}
  </label> -->
  {/each}
</div>

<style>
  label {
    text-align: left;
    margin-bottom: 0.5rem;
  }
  .checkbox-container {
    margin: auto;
    width: max-content;
    max-width: 100%;
  }
</style>
